<div *ngIf="showButton" class="fixed z-50 max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow-xl bottom-4 right-4">
  <div class="flex flex-col gap-3">
    <p class="text-sm font-medium text-gray-800">Instale nossa aplicação para uma melhor experiência.</p>
    <div class="flex flex-col gap-2">
      <button class="w-full px-4 py-2 text-sm font-medium text-white transition-colors bg-blue-500 rounded hover:bg-blue-600" (click)="installPwa()">
        Instalar agora
      </button>
      <button class="w-full px-4 py-2 text-sm font-medium text-gray-600 transition-colors bg-gray-100 rounded hover:bg-gray-200" (click)="dismiss()">
        Não quero instalar
      </button>
    </div>
  </div>
</div>
